import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dcbe2250"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "project_details_content"
}
const _hoisted_2 = {
  key: 1,
  class: "tw-flex tw-flex-col tw-justify-center tw-items-center tw-h-full tw-w-full tw-mt-[500px]"
}

import { ref, computed, watch, reactive, onBeforeMount } from "vue";
import {
  RouteLocationNormalized,
  onBeforeRouteLeave,
  useRoute,
} from "vue-router";
import { useStore } from "vuex";

import GbpCircleFilledIcon from "@/core/components/icons/GbpCircleFilledIcon.vue";
import EscrowAccount from "@/modules/project/components/EscrowAccount.vue";
import EstimateSummary from "@/modules/project/components/EstimateSummary.vue";
import TradesEstimates from "@/modules/project/components/TradesEstimates.vue";
import ProjectReviewComponent from "@/modules/project/components/ProjectReviewComponent.vue";
import SiteVisitRequestsPage from "@/modules/project/pages/SiteVisitRequestsPage.vue";
import { PROJECT_STORE } from "@/store/modules/project";
import PropertyProjectReview from "@/modules/project/components/PropertyProjectReview.vue";
import InviteContractorPage from "@/modules/project/pages/InviteContractorPage.vue";
import VideoConsultationPage from "@/modules/project/pages/VideoConsultationPage.vue";
import {
  ProjectJobStatusEnum,
  ProjectListStatusType,
  ProjectTypesEnum,
} from "@/core/enums/ProjectsEnum";
import { onMounted } from "vue";
import Loader from "@/core/components/common/Loader.vue";
import { JOBS_STORE } from "@/store/modules/jobs";
const ESTIMATE = "estimate";
const SCHEDULE = "schedule";
const SITE_VISIT = "sitevisit";
const ESTIMATE_SUMMARY = "estimate summary";
const ESCROW_ACCOUNT = "escrow account";
const INVITE = "invitees";
const VIDEO_CONSULTATION = "video consultation";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectDetailsPage',
  setup(__props) {

const gbpCircleFilledIcon = GbpCircleFilledIcon;

const store = useStore();
const route = useRoute();

const disputeProject = computed(() => {
  return store.getters[`${PROJECT_STORE}/getDisputeProject`];
});
const projectMenuWithoutAcceptedEstimates = [
  { name: "project-overview", icon: "mdi-home", label: "Project Details " },
  {
    name: "invite-contractors",
    label: "Invite Contractors",
    icon: "mdi-home",
  },
  {
    name: "trades-estimates",
    icon: "mdi-speedometer-slow",
    label: "Trades Estimates",
  },
  {
    name: "site-visit",
    label: "Site Visit Requests",
    icon: "mdi-home",
  },
  // {
  //   key: SCHEDULE,
  //   title: "Schedule",
  //   icon: "mdi-file-document",
  // },
  {
    name: VIDEO_CONSULTATION,
    label: "Video Consultation",
    icon: "mdi-video-minus",
  },
];

const filterMenu = computed(() => {
  return state.menu.filter((menuItem: any) => {
    if (menuItem.name === "trades-estimates") {
      if (
        [
          ProjectJobStatusEnum.QUOTES_RECEIVED,
          ProjectJobStatusEnum.QUOTE_ACCEPTED,
          ProjectJobStatusEnum.QUOTE_CONFIRMED,
          ProjectJobStatusEnum.IN_PROGRESS,
        ].includes(projectData.value.projectJobStatus.id)
      ) {
        return true;
      }
    } else if (menuItem.name === "site-visit") {
      if (
        projectData.value.siteVisitStatus &&
        [
          ProjectJobStatusEnum.QUOTES_RECEIVED,
          ProjectJobStatusEnum.QUOTE_ACCEPTED,
          ProjectJobStatusEnum.QUOTE_CONFIRMED,
          ProjectJobStatusEnum.IN_PROGRESS,
        ].includes(projectData.value.projectJobStatus.id)
      )
        return true;
      return false;
    } else if (menuItem.name === VIDEO_CONSULTATION) {
      if (
        [ProjectJobStatusEnum.IN_PROGRESS].includes(
          projectData.value.projectJobStatus.id
        )
      ) {
        return true;
      }
    } else {
      return true;
    }
  });
});

const projectMenuWithAcceptedEstimates = [
  { name: "project-overview", icon: "mdi-home", label: "Project Details" },
  {
    name: "escrow-account",
    icon: "mdi-currency-gbp",
    label: "Escrow Account",
  },
  {
    name: "estimate-summary",
    icon: "mdi-receipt-text-edit",
    label: "Estimate Summary",
  },
  // {
  //   key: SCHEDULE,
  //   title: "Schedule",
  //   icon: "mdi-file-document",
  // },
  {
    name: VIDEO_CONSULTATION,
    label: "Video Consultation",
    icon: "mdi-video-minus",
  },
];

const selectedTab = ref();
const projectRefId = ref(null) as any;
const loading = ref(false);
const state = reactive({
  // TEMPORARY STATE
  isProjectWithAcceptedEstimate: false,

  menu: [],
}) as any;
const projectData = ref(null) as any;

const getProjectRedirectTabName = computed(
  () => store.getters[`${PROJECT_STORE}/getProjectRedirectTabName`]
);
const isUpdate = ref(false);
const shouldDisableTab = (item: any) => {
  if (
    disputeProject.value?.estimatePhases?.length === 0 &&
    item.name !== "project-overview"
  ) {
    return true;
  }

  return false;
};
const switchToProjectOverView = () => {
  selectedTab.value = "project-overview";
};

watch(
  getProjectRedirectTabName,
  (newValue, oldValue) => {
    selectedTab.value = newValue;
  },
  { deep: true, immediate: true }
);

watch(
  selectedTab,
  async (newValue, oldValue) => {
    store.dispatch(`${PROJECT_STORE}/setProjectRedirectTabName`, newValue);
  },
  { deep: true, immediate: true }
);

onBeforeMount(async () => {
  if (route.params && route.params.refId) {
    projectRefId.value = route.params.refId;
  }
  let projectDetails = null;
  try {
    loading.value = true;
    projectDetails = await store.dispatch(`${PROJECT_STORE}/getProjectData`, {
      projectRefId: projectRefId.value,
    });

    if (projectDetails) {
      projectData.value = projectDetails;
      await store.dispatch(`${PROJECT_STORE}/projectDetails`, projectDetails);

      if (
        projectData.value?.projectJobStatus?.id ===
        ProjectJobStatusEnum.IN_PROGRESS
      ) {
        await store.dispatch(`${PROJECT_STORE}/getDisputeProject`, {
          projectRefId: projectRefId.value,
        });
      }
    }
    if (projectDetails?.projectEstimateId) {
      await store.dispatch(
        `${PROJECT_STORE}/setProjectEstimateEscrowBalance`,
        projectDetails?.id
      );

      await store.dispatch(
        `${PROJECT_STORE}/getProjectEstimateWithEscrow`,
        projectDetails?.projectEstimateId
      );
      if (
        projectData.value.projectJobStatus.id ===
        ProjectJobStatusEnum.QUOTE_ACCEPTED
      ) {
        state.menu = [projectMenuWithAcceptedEstimates[0]];
      } else if (
        projectDetails &&
        projectDetails?.type !== "video consultation"
      ) {
        let filterMenu = projectMenuWithAcceptedEstimates.filter(
          (ps) => ps.name !== VIDEO_CONSULTATION
        );
        state.menu = filterMenu;
      } else {
        state.menu = projectMenuWithAcceptedEstimates;
      }
    } else {
      state.menu = projectMenuWithoutAcceptedEstimates;
    }
  } catch (error) {
    console.log("error", error);
  } finally {
    loading.value = false;
  }
});
onBeforeRouteLeave(
  (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: () => void
  ) => {
    if (from.name === "projectDetails") {
      store.commit(`${PROJECT_STORE}/resetProjectDetails`, {});
      store.commit(`${JOBS_STORE}/setProjectDispute`, null);
    }
    next();
  }
);

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_v_tabs, {
            class: "tab-list",
            modelValue: selectedTab.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedTab).value = $event)),
            "align-tabs": "center",
            stacked: ""
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterMenu.value, (tabItem) => {
                return (_openBlock(), _createBlock(_component_v_tab, {
                  disabled: shouldDisableTab(tabItem),
                  key: tabItem.name,
                  value: tabItem.name
                }, {
                  default: _withCtx(() => [
                    (tabItem?.isIconComponent)
                      ? (_openBlock(), _createBlock(_resolveDynamicComponent(tabItem.icon), {
                          key: 0,
                          class: "!tw-mb-[5px]"
                        }))
                      : (_openBlock(), _createBlock(_component_v_icon, {
                          key: 1,
                          icon: tabItem.icon
                        }, null, 8, ["icon"])),
                    _createElementVNode("span", null, _toDisplayString(tabItem.label), 1)
                  ]),
                  _: 2
                }, 1032, ["disabled", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_v_window, {
            modelValue: selectedTab.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedTab).value = $event))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterMenu.value, (tabValue) => {
                return (_openBlock(), _createBlock(_component_v_window_item, {
                  key: tabValue.name,
                  value: tabValue.name,
                  class: "md:!tw-box-borders tw-pt-4"
                }, {
                  default: _withCtx(() => [
                    (projectRefId.value && tabValue.name === 'project-overview')
                      ? (_openBlock(), _createBlock(ProjectReviewComponent, {
                          key: 0,
                          projectRefId: projectRefId.value,
                          type: "projectDetails"
                        }, null, 8, ["projectRefId"]))
                      : _createCommentVNode("", true),
                    (
            tabValue.name === 'trades-estimates' &&
            selectedTab.value === 'trades-estimates'
          )
                      ? (_openBlock(), _createBlock(TradesEstimates, {
                          key: 1,
                          projectId: projectData.value?.id
                        }, null, 8, ["projectId"]))
                      : _createCommentVNode("", true),
                    (
            tabValue.name === 'escrow-account' &&
            selectedTab.value === 'escrow-account'
          )
                      ? (_openBlock(), _createBlock(EscrowAccount, { key: 2 }))
                      : _createCommentVNode("", true),
                    (tabValue.name === 'estimate-summary')
                      ? (_openBlock(), _createBlock(EstimateSummary, {
                          key: 3,
                          onSwitchToProjectOverview: switchToProjectOverView
                        }))
                      : _createCommentVNode("", true),
                    (tabValue.name === 'site-visit' && selectedTab.value === 'site-visit')
                      ? (_openBlock(), _createBlock(SiteVisitRequestsPage, {
                          key: 4,
                          projectId: projectData.value?.id
                        }, null, 8, ["projectId"]))
                      : _createCommentVNode("", true),
                    (selectedTab.value === 'invite-contractors')
                      ? (_openBlock(), _createBlock(InviteContractorPage, { key: 5 }))
                      : _createCommentVNode("", true),
                    (selectedTab.value === VIDEO_CONSULTATION)
                      ? (_openBlock(), _createBlock(VideoConsultationPage, {
                          key: 6,
                          projectDetails: projectData.value
                        }, null, 8, ["projectDetails"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(Loader, { show: loading.value }, null, 8, ["show"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})